import React from 'react'
import { graphql} from 'gatsby'
import { Link} from 'gatsby'
import { LinkResolver } from '@utils/LinkResolver'
import Layout from '@layout'
import SEO from '@layout/SEO'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import PageDescription from '@components/PageDescription.js'

export const query = graphql `
query 
{
  prismic{
    allLegislator_orientation_homes(id:null){
      edges{
        node{
          _meta{
            uid
            id
            type
          }
          page_title
          page_description
        }
      }
    }
    allLegislator_orientations(sortBy: year_range_DESC) {
        edges {
            node {
                _meta {
                    uid
                    type
                }
                page_title
                year_range
                page_description
            }
        }
    }
  }
}
`

const OrientationLinks = ({orientationLinks}) => {
    if (orientationLinks === null || orientationLinks.length === 0) return null
    return (
        <>
            {orientationLinks.map((node) => {
                return (
                <h2 className="h4 py-2" key={node.node._meta.uid}> 
                    <Link className="animated" to={LinkResolver(node.node._meta)}>{node.node.year_range}</Link>
                </h2>
                )            
            })}
        </>
    )
}

export default (props) => {
    const doc = props.data.prismic.allLegislator_orientation_homes.edges.slice(0,1).pop();
    const orientationLinks = props.data.prismic.allLegislator_orientations.edges;

    if(!doc) return null;
    if (typeof window !== "undefined"){
        return(
            <Layout>
                <SEO title={doc.node.page_title}  pathname={props.location.pathname}/>
                <Row>
                    <Col>
                        <h1 className="pb-2">{doc.node.page_title}</h1>
                        <div>
                            <PageDescription description={doc.node.page_description}/>
                        </div>
                    </Col>
                </Row>
                <hr className="my-4"/>
                <Row>
                    <Col>
                        <OrientationLinks orientationLinks={orientationLinks}/>
                    </Col>
                </Row>
            </Layout>       
        )
    }
    else return null;
}